// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--GVmm9","V2FormInputNoColon":"V2FormInputNoColon--d6FSN","markerAnimationScale":"markerAnimationScale--yHxSu"};